<template lang='pug'>
    div
      span(style='font-weight: 500') {{title}}:
      span(style='font-weight: 300; margin-left:2%') {{value}}
</template>

<script>

export default {
  props: {
    value: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style>

</style>
